module.exports = __webpack_public_path__ + "fccd8328c492d6ba5d2a6634d7ba18e8.svg";